import { render } from "./WordSwipe.vue?vue&type=template&id=5fb779d6&scoped=true"
import script from "./WordSwipe.vue?vue&type=script&lang=js"
export * from "./WordSwipe.vue?vue&type=script&lang=js"

import "./WordSwipe.vue?vue&type=style&index=0&id=5fb779d6&scoped=true&lang=scss"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb779d6"]])

export default __exports__